export const invertedMessages = {
  'There was a problem loading your shortcuts. Refresh the page to retry.':
    'Nav.ShortcutsWidget.RequestError',
} as const;

export const messages: Record<string, string> = {
  'Nav.ShortcutsWidget.Shortcut-view-saved-requests': 'View Saved Requests',
  'Nav.ShortcutsWidget.Shortcut-request-history': 'View Request History',
  'Nav.ShortcutsWidget.Shortcut-pending-approvals': 'Review Pending Requests',
  'Nav.ShortcutsWidget.Shortcut-manage-my-access': 'Manage My Access',
  'Nav.ShortcutsWidget.Shortcut-manage-delegate': 'Manage Delegation',
  'Nav.ShortcutsWidget.Shortcut-change-account-password-for-self':
    'Change My Account Password',
  'Nav.ShortcutsWidget.Shortcut-reset-account-password-for-others':
    'Reset Others Account Password',
  'Nav.ShortcutsWidget.Shortcut-reset-user-password': 'Reset User Password',
  'Nav.ShortcutsWidget.Shortcut-reset-service-account-password':
    'Change Service Account Password',
  'Nav.ShortcutsWidget.Shortcut-request-emergency-access-IDs':
    'Request Emergency IDs',
  'Nav.ShortcutsWidget.Shortcut-request-emergency-access-roles':
    'Request Emergency Roles',
  'Nav.ShortcutsWidget.Shortcut-view-existing-access': 'View Existing Access',
  'Nav.ShortcutsWidget.Shortcut-pending-tasks': 'View Pending Tasks',
  'Nav.ShortcutsWidget.Shortcut-manage-service-accounts':
    'Manage Service Accounts',
  'Nav.ShortcutsWidget.Shortcut-create-new-endpoint': 'Create a New Endpoint',
  'Nav.ShortcutsWidget.Shortcut-update-existing-endpoint':
    'Update Existing Endpoint',
  'Nav.ShortcutsWidget.Shortcut-one-click-disable': 'One Click Disable',
  'Nav.ShortcutsWidget.Shortcut-create-new-entitlement':
    'Create a New Entitlement',
  'Nav.ShortcutsWidget.Shortcut-update-existing-entitlement':
    'Update Existing Entitlement',
  'Nav.ShortcutsWidget.Shortcut-create-user-request': 'Create a User Request',
  'Nav.ShortcutsWidget.Shortcut-update-user-request': 'Update a User Request',
  'Nav.ShortcutsWidget.Shortcut-custom:start-access-request':
    'Start an Access Request',
} as const;
